(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessory-model-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mw-accessory-picker')) {
    customElements.define('mw-accessory-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const start = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.controller.signal });
        } else {
          this.frame = requestAnimationFrame(start);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.scope?.classList.remove('mw-accessory-model-active');
      }

      initialize() {
        if (!this.isConnected) return;
        this.options = this.querySelector('[data-mw-options]');
        this.counter = this.querySelector('[data-mw-result-count]');
        this.emptyMessage = this.querySelector('[data-mw-empty]');
        this.scope = this.closest('[data-section-type="collection-grid"]');
        if (!this.options || !this.counter || !this.emptyMessage || !this.scope) return;

        try {
          this.labels = JSON.parse(this.options.dataset.countLabels);
          this.cards = Array.from(this.querySelectorAll('[data-mw-models]'), node => {
            const models = JSON.parse(node.dataset.mwModels);
            return { node, models: Array.isArray(models) ? models : [] };
          });
        } catch (_) {
          return; // Keep the unfiltered collection usable if any metadata is invalid.
        }
        if (this.labels.length !== this.cards.length + 1) return;

        this.models = { 'alpha-600': 'Alpha 600', 'alpha-800': 'Alpha 800', 'alpha-camp': 'Alpha Camp' };
        this.buttons = Array.from(this.options.querySelectorAll('[data-mw-choice]'));
        this.facets = Array.from(this.scope.querySelectorAll('.filter-form input[type="checkbox"]'), input => ({
          input,
          label: input.closest('label')?.querySelector('.tag__text')?.textContent.trim(),
          originalLabel: input.getAttribute('aria-label')
        }));
        const signal = this.controller.signal;
        this.options.addEventListener('click', event => {
          const button = event.target.closest('button[data-mw-choice]');
          if (!button || !this.options.contains(button)) return;
          const choice = button.dataset.mwChoice;
          const url = new URL(window.location.href);
          url.hash = this.models[choice] ? 'mw-' + choice : '';
          if (url.href !== window.location.href) history.pushState(history.state, '', url);
          this.applySelection();
        }, { signal });
        window.addEventListener('popstate', () => this.applySelection(), { signal });
        window.addEventListener('hashchange', () => this.applySelection(), { signal });
        document.addEventListener('collection:reloaded', () => this.applySelection(), { signal });
        this.options.hidden = false;
        this.applySelection();
      }

      applySelection() {
        const key = window.location.hash.replace(/^#mw-/, '');
        const selected = this.models[key] ? key : 'all';
        let visibleCount = 0;
        this.cards.forEach(({ node, models }) => {
          const visible = selected === 'all' || models.includes(this.models[selected]);
          node.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        this.buttons.forEach(button => {
          const choice = button.dataset.mwChoice;
          const count = choice === 'all' ? this.cards.length : this.cards.filter(card => card.models.includes(this.models[choice])).length;
          button.setAttribute('aria-pressed', String(choice === selected));
          button.querySelector('[data-mw-option-count]').textContent = '(' + count + ')';
        });
        this.counter.textContent = this.labels[visibleCount];
        this.emptyMessage.hidden = visibleCount > 0;
        this.scope.classList.toggle('mw-accessory-model-active', selected !== 'all');
        this.facets.forEach(({ input, label, originalLabel }) => {
          if (selected !== 'all' && label) input.setAttribute('aria-label', label);
          else if (originalLabel === null) input.removeAttribute('aria-label');
          else input.setAttribute('aria-label', originalLabel);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-addon-total"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mw-addon-total')) {
    customElements.define('mw-addon-total', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.form = this.closest('form');
        this.root = this.closest('.product-section');
        if (!this.form || !this.root) return;
        try {
          this.variants = JSON.parse(this.querySelector('script').textContent);
          this.formatter = new Intl.NumberFormat(this.dataset.locale, {
            style: 'currency', currency: this.dataset.currency
          });
        } catch { return; }
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.onImageAction = event => {
          const image = event.target.closest('lb-addon lb-card-image');
          if (!image || !this.root.contains(image)) return;
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          const checkbox = image.closest('.lb-product-card')?.querySelector('.lb-card-checkbox');
          if (!checkbox) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (checkbox.disabled || event.repeat) return;
          // Delegate to Selleasy's own control so selection and bundle state stay in sync.
          checkbox.click();
          this.schedule();
        };
        this.root.addEventListener('click', this.onImageAction, true);
        this.root.addEventListener('keydown', this.onImageAction, true);
        ['change', 'input', 'click', 'variant:change'].forEach(name => {
          this.root.addEventListener(name, this.schedule);
        });
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.root, {
          subtree: true, childList: true, characterData: true, attributes: true,
          attributeFilter: ['checked', 'value', 'class', 'disabled', 'lb-price', 'lb-default-price', 'lb-variant-id']
        });
        this.update();
      }
      disconnectedCallback() {
        this.root?.removeEventListener('click', this.onImageAction, true);
        this.root?.removeEventListener('keydown', this.onImageAction, true);
        ['change', 'input', 'click', 'variant:change'].forEach(name => {
          this.root?.removeEventListener(name, this.schedule);
        });
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
      }
      moneyValue(node) {
        if (!node) return NaN;
        const text = node.textContent.replace(/[^0-9.,]/g, '');
        if (!text) return NaN;
        const fractional = text.match(/[.,](\d{2})$/);
        const whole = fractional ? text.slice(0, -3) : text;
        return Number(whole.replace(/[.,]/g, '')) * 100 + Number(fractional?.[1] || 0);
      }
      update() {
        const cards = [...this.root.querySelectorAll('lb-addon .lb-product-card')];
        for (const card of cards) {
          const checkbox = card.querySelector('.lb-card-checkbox');
          const image = card.querySelector('lb-card-image');
          if (checkbox && image) {
            image.setAttribute('role', 'button');
            image.setAttribute('tabindex', checkbox.disabled ? '-1' : '0');
            image.setAttribute('aria-pressed', String(checkbox.checked));
            image.setAttribute('aria-disabled', String(checkbox.disabled));
          }
          const title = card.querySelector('.lb-card-title[role="link"]');
          if (title) title.setAttribute('tabindex', '0');
        }
        // One subtotal in the existing form, directly before its submit button, at every width.
        const variant = this.variants.find(item => String(item.id) === this.form.elements.namedItem('id')?.value);
        if (!cards.length || !variant || this.form.elements.namedItem('selling_plan')?.value) {
          this.hidden = true;
          return;
        }
        const quantityInput = this.form.elements.namedItem('quantity') ||
          this.root.querySelector('.product__quantity [name="quantity"]');
        const mainQuantity = Number(quantityInput?.value || 1);
        let total = variant.price * mainQuantity;
        for (const card of cards) {
          if (!card.querySelector('.lb-card-checkbox:checked')) continue;
          const price = this.moneyValue(card.querySelector('.lb-price-sale-price'));
          const quantity = Number(card.querySelector('input[type="number"]')?.value || 1);
          if (!Number.isFinite(price) || !Number.isInteger(quantity) || quantity < 1) {
            this.hidden = true;
            return;
          }
          total += price * quantity;
        }
        if (!Number.isSafeInteger(total) || !Number.isInteger(mainQuantity) || mainQuantity < 1) {
          this.hidden = true;
          return;
        }
        const text = this.formatter.format(total / 100);
        const output = this.querySelector('strong');
        if (output.textContent !== text) output.textContent = text;
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
